export enum UnitOfMeasures {
  each = 'Each',
  sqMetres = 'SQ METRES',
}
